import React from 'react';
import '../styles/footer.css';

function Footer() {
  return (
    <footer className="footer">
      <span className="footer-address">
        Quantena AG, Gotthardstr. 26, 6300 Zug, Switzerland
      </span>
      <span className="footer-copyright">
        &copy; {new Date().getFullYear()} Quantena AG
      </span>
    </footer>
  );
}

export default Footer;
